import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { CalculationKeynameEnum } from '../../../../../../../../common/src/enums/calculations/calculation-keyname.enum';
import { CalculationStatusEnum } from '../../../../../../../../common/src/enums/calculations/calculation-status.enum';
import { CalculationStore } from '../../stores/calculation.store';
import { MenuService } from '../../../core/services/menu.service';
import { IndexedDbService } from '../../../core/services/indexed-db.service';
import { CalculationResponse } from '../../../../../../../../common/dist/angular/responses/calculation.response';
import { CalculationLifecycleManager } from '../../managers/calculation-lifecycle.manager';
import { MagienoObservabilityManager } from '../../../core/managers/magieno-observability.manager';

@Component({
  selector: 'app-get-calculation',
  templateUrl: './get-calculation.component.html',
  styleUrls: ['./get-calculation.component.scss'],
  standalone: false,
})
export class GetCalculationComponent implements OnInit, OnDestroy {

  calculationId: string;

  calculationKeyname: CalculationKeynameEnum;

  calculationResponse: CalculationResponse;

  calculationStoreSubscription?: Subscription;
  paramsSubscription?: Subscription;

  startedRunningCalculationAt = new Date();
  startedRunningCalculationInterval;

  constructor(public menuService: MenuService,
              private readonly calculationStore: CalculationStore,
              private readonly indexedDbService: IndexedDbService,
              private readonly router: Router,
              private readonly calculationLifecycleManager: CalculationLifecycleManager,
              private readonly observabilityManager: MagienoObservabilityManager,
              private readonly route: ActivatedRoute) {
  }

  async ngOnInit() {
    const params = this.route.snapshot.params;
    this.calculationId = params.calculationId;
    this.calculationKeyname = params.calculationKeyname;
    this.paramsSubscription = this.route.paramMap.subscribe(async params => {
      this.calculationId = params.get('calculationId');
      this.calculationKeyname = params.get('calculationKeyname') as CalculationKeynameEnum;
      await this.init();
    });
  }

  ngOnDestroy() {
    this.unsubscribeAll();
  }

  unsubscribeAll() {
    this.calculationStoreSubscription?.unsubscribe();
    this.paramsSubscription?.unsubscribe();
    this.calculationStore.stopAutoRefresh(this.calculationId);
  }

  async init(): Promise<void> {
    // Subscribe to the store to be notified on every update of the calculation response.
    this.calculationStoreSubscription = this.calculationStore.get(this.calculationId).subscribe(async calculationResponse => {
      if (calculationResponse === undefined) {
        return;
      }

      this.calculationResponse = calculationResponse;

      // If status is IN_PROGRESS, we start checking for the calculation results at interval
      if (calculationResponse.status === CalculationStatusEnum.InProgress) {
        this.calculationStore.startAutoRefresh(this.calculationId);
      } else {
        this.calculationStore.stopAutoRefresh(this.calculationId);
      }
    });

    /*this.calculationLifecycleManager.calculationStartedRunning.subscribe(value => {
      this.startedRunningCalculationInterval = setInterval(() => {
        this.checkCalculationRunningExecutionTime();
      }, 5000)
      this.startedRunningCalculationAt = new Date();
    });

    this.calculationLifecycleManager.calculationCompleted.subscribe(value => {
      clearInterval(this.startedRunningCalculationInterval);
      this.startedRunningCalculationAt = undefined;
    })*/
  }

  /*async checkCalculationRunningExecutionTime() {
    if (this.startedRunningCalculationAt !== undefined && differenceInSeconds(new Date(), this.startedRunningCalculationAt) > 30) {
      await this.observabilityManager.sendAlert("CRITICAL", "calculation running - The calculation has been running for more than 30 seconds.", {
        calculationId: this.calculationId,
        calculationResponse: this.calculationResponse,
        calculationKeyname: this.calculationKeyname,
      });
      clearInterval(this.startedRunningCalculationInterval);
      this.startedRunningCalculationAt = undefined;
    }
  }*/

}
